import * as React from "react"
import { Link } from "gatsby"
import { contactEnabled } from "../../site-config"
import * as contactLinkStyles from "./contactlink.module.css"

/*
 * The "Entre em contato →" call to action at the end of Sobre. It is the only
 * link to /contact/ outside the navbar, so it comes and goes with the route —
 * see site-config.js. With Contato off it renders nothing, and the footer's
 * phone, email and WhatsApp are what people reach for instead.
 */
const ContactLink = () => {
    if (!contactEnabled) return null

    return (
        <p className={contactLinkStyles.heading}>
            <Link to="/contact/">Entre em contato&#xFEFF; →</Link>
        </p>
    )
}

export default ContactLink
